import { apiGet, apiPost, apiPut, apiDelete } from "./api";

export interface Workspace {
  id: string;
  name: string;
  n8nUrl: string;
  proxyUrl?: string;
  createdAt: string;
  updatedAt: string;
}

export async function getWorkspaces(): Promise<Workspace[]> {
  return apiGet<Workspace[]>("/api/workspaces");
}

export async function getWorkspace(id: string): Promise<Workspace | undefined> {
  try {
    return await apiGet<Workspace>(`/api/workspaces/${id}`);
  } catch {
    return undefined;
  }
}

export async function createWorkspace(data: {
  name: string;
  n8nUrl: string;
}): Promise<Workspace> {
  return apiPost<Workspace>("/api/workspaces", data);
}

export async function updateWorkspace(
  id: string,
  data: Partial<Pick<Workspace, "name" | "n8nUrl" | "proxyUrl">>,
): Promise<Workspace> {
  return apiPut<Workspace>(`/api/workspaces/${id}`, data);
}

export async function deleteWorkspace(id: string): Promise<void> {
  await apiDelete(`/api/workspaces/${id}`);
}
